import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";
import { CourseTermsFormValues } from "components/templates/AddTermsModal/CreateTermsForm";
import { UpdateTermsFormValues } from "components/templates/AddTermsModal/UpdateTermsForm";

const getByCourseId = (courseId: number): AxiosPromise<{ terms: CourseTermsApi[] }> => {
  return api.get<{ terms: CourseTermsApi[] }>(endpoints.COURSE_TERMS.GET_BY_COURSEID(courseId));
};

const create = (courseId: number, body: CourseTermsFormValues): AxiosPromise<number> => {
  const formData = new FormData();

  // @ts-expect-error - file type
  formData.append("terms", body.terms[0] as File);
  formData.append("name", body.name);
  formData.append("description", body.description ?? "");
  return api.post<number>(endpoints.COURSE_TERMS.CREATE(courseId), formData);
};

const update = (courseId: number, courseTermsId: number, body: UpdateTermsFormValues): AxiosPromise<void> => {
  return api.put<void>(endpoints.COURSE_TERMS.UPDATE(courseId, courseTermsId), body);
};
const deleteResource = (courseId: number, courseTermsId: number): AxiosPromise<void> => {
  return api.delete<void>(endpoints.COURSE_TERMS.DELETE(courseId, courseTermsId));
};

export const courseTermsApi = {
  getByCourseId,
  create,
  deleteResource,
  update,
};

export interface CourseTermsApi {
  id: number;
  name: string;
  description: string;
  link: string;
}
